// ─────────────────────────────────────────────────────────────────────────────
// SITE ENHANCEMENTS
// 1. Close the full-screen mobile menu when a menu item is tapped (one-pager
//    anchor links would otherwise leave the menu covering the page).
// 2. Persistent mobile "Book a free 15-minute chat" bar — visible only while
//    scrolling through the middle of the page, hidden over the hero and over
//    the contact/footer (where a CTA is already present).
// ─────────────────────────────────────────────────────────────────────────────

(() => {
    // ---- 1. Close mobile menu on link tap ----
    const nav = document.querySelector("#cs-navigation");
    const toggle = document.querySelector("#cs-toggle");
    const menuWrapper = document.querySelector("#cs-ul-wrapper");

    if (nav && toggle && menuWrapper) {
        menuWrapper.querySelectorAll("a").forEach((link) => {
            link.addEventListener("click", () => {
                // Reuse the nav controller's own close logic by clicking the toggle
                if (nav.classList.contains("cs-active")) {
                    toggle.click();
                }
            });
        });
    }

    // ---- 2. Persistent mobile CTA bar ----
    const bar = document.querySelector("#jl-sticky-cta");
    if (!bar) return;

    // No IntersectionObserver (very old browser): just show it and bail.
    if (!("IntersectionObserver" in window)) {
        bar.classList.remove("is-hidden");
        return;
    }

    // Hide the bar whenever any of these "already has a CTA" zones is on screen.
    const zones = ["#hero", "#contact", "#cs-footer"]
        .map((sel) => document.querySelector(sel))
        .filter(Boolean);

    const visibleZones = new Set();

    const observer = new IntersectionObserver(
        (entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) visibleZones.add(entry.target);
                else visibleZones.delete(entry.target);
            });
            bar.classList.toggle("is-hidden", visibleZones.size > 0);
        },
        { rootMargin: "0px 0px -15% 0px" }
    );

    zones.forEach((zone) => observer.observe(zone));
})();
